import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Main from "./Main";
import { WalletProvider } from "./context/WalletContextProvider";
import { ErrorProvider } from "./context/ErrorContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorProvider>
      <WalletProvider>
        <Main />
      </WalletProvider>
    </ErrorProvider>
  </React.StrictMode>
);

// Web vitals reporting removed for production simplification.
